import React from 'react';
import { useTranslation } from 'react-i18next';
import ComparePage from './ComparePage';

const BANKS = [
  {
    name: 'Scotiabank',
    cardName: 'Scotiabank StartRight Mastercard',
    cardData: {
      bank: 'Scotiabank',
      annual_fee: 'No annual fee',
      newcomer_friendly: true,
      rewards: '1% cash back on all eligible purchases',
    },
  },
  {
    name: 'BMO',
    cardName: 'BMO CashBack Mastercard',
    cardData: {
      bank: 'BMO',
      annual_fee: 'No annual fee',
      newcomer_friendly: true,
      rewards: '0.5% cash back on all purchases',
    },
  },
];

const ROWS = [
  { label: 'Cuota anual', values: ['Sin cuota', 'Sin cuota'] },
  { label: 'Cash back', values: ['1% en todas las compras', '0.5% en todas las compras'] },
  { label: 'Programa newcomer', values: ['Si - Scotiabank StartRight', 'Si - BMO NewStart'] },
  { label: 'App movil', values: ['Scotia Mobile - 3.7/5', 'BMO Mobile - 3.8/5'] },
  { label: 'Soporte en espanol', values: ['Si (linea dedicada + sucursales)', 'Parcial (sucursales selectas)'] },
  { label: 'Presencia en Latinoamérica', values: ['Si - presente en Mexico, Colombia, Peru, Chile', 'Limitada'] },
  { label: 'Seguro de viaje', values: ['No incluido', 'No incluido'] },
  { label: 'Transferencias internacionales', values: ['Scotiabank Transfer - tarifas preferenciales', 'Tarifas estandar'] },
];

const FAQS = [
  {
    question: 'Scotiabank o BMO, ¿cuál es mejor para latinos?',
    answer: 'Scotiabank tiene una ventaja significativa para latinos gracias a su presencia en Latinoamérica, soporte en espanol mas robusto, y su programa StartRight diseñado especificamente para recien llegados con 1% cash back desde el dia uno.',
  },
  {
    question: 'Puedo transferir dinero a Latinoamérica mas barato con Scotiabank?',
    answer: 'Si. Scotiabank ofrece tarifas preferenciales para transferencias a países donde tiene presencia (Mexico, Colombia, Peru, Chile). Esto puede ahorrarte dinero comparado con servicios como Western Union.',
  },
  {
    question: 'BMO tiene algun beneficio que Scotiabank no tiene?',
    answer: 'BMO ofrece una app movil ligeramente mejor valorada y su programa de recompensas AIR MILES en tarjetas premium. Sin embargo, para recien llegados con tarjeta basica, Scotiabank ofrece mejor cash back (1% vs 0.5%).',
  },
];

const RELATED = [
  { to: '/comparar/rbc-vs-td-recien-llegados', label: 'RBC vs TD para recien llegados' },
  { to: '/comparar/rbc-vs-desjardins-quebec', label: 'RBC vs Desjardins en Quebec' },
  { to: '/comparar/mejores-bancos-recien-llegados-canada-2026', label: 'Mejores bancos para recien llegados 2026' },
];

const ScotiabankVsBmoPage = () => {
  const { i18n } = useTranslation();
  return (
  <ComparePage
    seoTitle="Scotiabank vs BMO para recién llegados a Canada 2026"
    seoDescription="Comparacion entre Scotiabank y BMO para recién llegados latinoamericanos. Cash back, soporte en espanol, transferencias internacionales y FinMaple Score."
    seoKey="compararScotiaBmo"
    noIndex={i18n.language !== 'es'}
    canonical="/comparar/scotiabank-vs-bmo-inmigrantes"
    routeKey="compararScotiaBmo"
    breadcrumbLabel="Scotiabank vs BMO"
    atomicAnswer="Scotiabank supera a BMO para recién llegados latinos gracias a su presencia en Latinoamérica, mejor soporte en espanol, y 1% cash back sin cuota anual con su tarjeta StartRight. BMO es buena opcion pero ofrece menos beneficios especificos para newcomers."
    banks={BANKS}
    comparisonRows={ROWS}
    veredicto="Scotiabank es el ganador claro para recién llegados latinoamericanos. Su presencia en países de Latinoamérica facilita las transferencias internacionales, su soporte en espanol es superior, y la tarjeta StartRight ofrece el doble de cash back que BMO (1% vs 0.5%). Si envias dinero regularmente a tu familia en Latinoamérica, Scotiabank es la mejor opcion."
    faqs={FAQS}
    mayaText="Quieres saber cual banco te conviene mas? Preguntale a Maya y te orienta según tu situacion migratoria y necesidades."
    relatedLinks={RELATED}
  />
  );
};

export default ScotiabankVsBmoPage;
